import { initializeApp } from "firebase/app";
import { collection, doc, setDoc, getDoc, getDocs, getFirestore, query, where } from "firebase/firestore";

//setup firebaseConfig production
var firebaseConfig = {
  apiKey: "AIzaSyCNXy5cCQZdNEnSOOXecJb-ejMfpLOxRK0",
  authDomain: "wrapp-waste.firebaseapp.com",
  databaseURL: "https://wrapp-waste.firebaseio.com",
  projectId: "wrapp-waste",
  storageBucket: "wrapp-waste.appspot.com",
  messagingSenderId: "662553288814",
  appId: "1:662553288814:web:90dd222d1fe2d6766ac67f",
  measurementId: "G-KV0CXS3XRV"
};
initializeApp(firebaseConfig);

const db = getFirestore();

const fetchBookings = async (userId) => {
  const q = query(collection(db, 'bookings'), where('driver.id', '==', userId), where('status.delivery.driver', '==', 'ASSIGNED'));
  return await getDocs(q)
  .then((snapshot) => {
    let bookings = [];
    snapshot.forEach((booking) => {
      bookings.push({ ...booking.data(), id: booking.id });
    });
    return bookings;
  });
}

const driverModule = {
  namespaced: true,
  state: () => ({
    bookings: undefined,
    drivers: undefined,
    location: {},
    locations: [],
    positions: [],
    driver: {}
  }),
  getters: {
    getBookings: (state) => {
      return state.bookings;
    },
    getLocation: (state) =>{
      return state.location;
    },
    getLocations: (state) => {
      return state.locations;
    },
    getPositions: (state) => {
      return state.positions;
    },
    getDriverById: (state) => (driverId) => {
      if (state.drivers) return state.drivers.find((driver) => { return driver.id === driverId });
    },
    getDrivers: (state) => state.drivers ?? []
  },
  mutations: {
    setBookings(state, bookings) {
      state.bookings = bookings;
    },
    setDrivers(state, drivers) {
      state.drivers = drivers;
    },
    setLocation(state, location){
      state.location = location;
    },
    setPositions(state, positions){
      state.positions = positions;
    },
    setDriverLocations(state, locations){
      state.locations = locations;
    }
  },
  actions: {
    loadBookings(context, userId) {
      fetchBookings(userId)
        .then((bookings) => {
          context.commit('setBookings', bookings);
        })
        .catch((error) => {
          console.log(error);
          alert(error.message);
        });
    },
    fetchDrivers(context) {
      if (!context.state.drivers) {
        const q = query(collection(db, 'users'), where('scope', '==', 'driver'));
        getDocs(q)
        .then((snapshot) => {
          const drivers = [];
          snapshot.forEach((user) => {
            const driver = {...user.data(), id: user.id};
            drivers.push(driver);
          });
          context.commit('setDrivers', drivers);
        });   
      }
    },
    async updateDriver(context, user) {
      const docRef = doc(db, 'users', user.id);
      await setDoc(docRef, user, { merge: true })
      .then(() => { 
        context.commit('setLocation', user)
      })
      .catch((error) => {
        console.log(error);
        alert(error);
      });
    },
    async getDriverLocations(context, bookingId){
      let drivers = [];
      let users = [];
      let center = [];
      await getDoc(doc(db, 'bookings', bookingId))
      .then((booking) => {
        drivers = booking.data().drivers;
        drivers.forEach(async (driverId) => {
          await getDoc(doc(db, 'users', driverId))
            .then((user) => {
              if(user.exists()){
                users.push({
                  lat: Number.parseFloat(user.data().lat),
                  lng: Number.parseFloat(user.data().long)
                });
                center.push({
                  lat: Number.parseFloat(user.data().lat),
                  lng: Number.parseFloat(user.data().long)
                })
              }
            })
            .catch((err) => console.log(err))
        })
        context.commit('setPositions', center);
        context.commit('setDriverLocations', users);
      })
      .catch((err) =>{
        console.log(err);
        //alert(err);
      })

    }
  }
}

export default driverModule;